import { headers } from './requestConfig';
import {
  createContract,
  extendContract,
  contractsAuto,
  contractsAutoPreview,
  contractsCancelExtension,
  financeContracts,
} from '../service/links';

export const sendContractOffer = async ({ player, wage, playTime, length }) => {
  const response = await fetch(createContract, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({ player, wage, playTime, length }),
  });
  return response;
};

export const extendContractOffer = async ({ player, wage, playTime, length }) => {
  const response = await fetch(extendContract, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({ player, wage, playTime, length }),
  });
  return response;
};

export const getFinanceContracts = async () =>
  fetch(financeContracts, {
    method: 'GET',
    headers,
    credentials: 'include',
  });

export const getAutoContracts = async () =>
  fetch(contractsAuto, {
    method: 'GET',
    headers,
    credentials: 'include',
  });

export const postAutoContracts = async (body) =>
  fetch(contractsAuto, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify(body),
  });

export const getAutoContractsPreview = async (playerId) => {
  const url = playerId
    ? `${contractsAutoPreview}?player=${encodeURIComponent(playerId)}`
    : contractsAutoPreview;
  return fetch(url, {
    method: 'GET',
    headers,
    credentials: 'include',
  });
};

export const cancelContractExtension = async (player) =>
  fetch(contractsCancelExtension, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({ player }),
  });
